<template>
  <div>
    <LoadingSpinner :loading="loading" :text="$lang.sending_data" />
    <b-row v-if="!loading">
      <b-col cols="12" md="12" class="mb-3">
        <strong v-text="$lang.term_select_items_info" />
      </b-col>
      <b-col cols="12" md="12" v-for="item in checkItems" :key="item.name">
        <b-form-group label-cols="3" :label="item.caption" class="mb-1">
          <b-form-checkbox
            v-model="item.value"
            :name="item.name"
            switch
            class="mt-2"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12" class="mt-3 text-right">
        <b-button variant="success" @click="submit">
          {{ $lang.submitButton }}
          <mdicon name="check" size="20" />
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  components: {
    LoadingSpinner,
  },
  props: {
    extraFields: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      code: this.$route.params.code,
      loading: false,
      checkItems: [
        {
          value: false,
          name: "profile_image",
          caption: "عکس پروفایل",
        },
        {
          value: false,
          name: "birth_date",
          caption: "تاریخ تولد",
        },
        {
          value: false,
          name: "education_grade",
          caption: "سطح مدرک تحصیلی",
        },
        {
          value: false,
          name: "sokonat_city",
          caption: "شهر محل سکونت ",
        },
        {
          value: false,
          name: "job_info",
          caption: "اطلاعات شغل فعلی",
        },
      ],
    };
  },
  created() {
    this.checkItems = this.checkItems.map((item) => {
      item.value = !!pathOr(false, [item.name], this.extraFields);
      return item;
    });
  },
  methods: {
    pathOr,
    generateApiUrl,
    async submit() {
      try {
        this.loading = true;
        const url = generateApiUrl(
          ["profile", "term_extra_profile"],
          [this.code]
        );
        const payload = {};
        for (const item of this.checkItems) {
          payload[item.name] = item.value;
        }
        const response = await this.$httpService.put(url, payload);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
